import React, { FunctionComponent } from 'react';

type Props = {
  tags: string[];
  onTagClick: (tag: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  tags,
  onTagClick,
}) => {
  return (
    <div className="tv-tagsearch gtm-tv_tag-view-count" data-event-name='tv_tag on screen' data-category="tvlist" data-value="tag">
      {tags.map((tag) => (
        <span
          key={tag}
          className="tv-tagsearch-item"
          onClick={() => onTagClick(tag)}
          data-category="tvlist"
          data-value="tag"
        >
          <i>{tag}</i>
        </span>
      ))}
    </div>
  );
};
